import { useAuth } from "../contexts/AuthContext";

interface AgentCardProps {
    name?: string;    
    joinDate?: string; 
    userId?: string;
    currentUserId?: string;
    onDelete: () => void;
    onHistoryClick: () => void;
    currentUserRoles:string[];
}


function AgentCard({ name, joinDate, userId,currentUserId, onDelete, currentUserRoles }: AgentCardProps) {
    const { user, isManager } = useAuth();
    const isSuperAdmin = () => currentUserRoles?.includes('Super Admin');
 
    return (
        <div className="bg-white shadow-[0_2px_18px_-6px_rgba(0,0,0,0.2)] mb-4 px-6 py-3 w-[100%] rounded-xl">
        <div className="flex items-center justify-between">
            <div>
                <p className="text-base font-medium">{name} {currentUserId === userId ? "(You)" : ""}</p>
                <p className="text-xs text-custom-gray lg:text-sm">Joined {joinDate}</p>
            </div>
            <div className="hidden md:flex flex-row items-center justify-center">
                {/* <button onClick={onHistoryClick}
                        className="custom-button btn-nav">
                    History
                </button> */}
                {isSuperAdmin() &&
                <button onClick={onDelete}
                        className={`custom-button btn-nav ${currentUserId === userId ? 'text-gray-400 cursor-not-allowed' : 'text-red-400 hover:text-red-600'}`}
                        disabled={currentUserId === userId}>
                    Remove user
                </button>}
            </div>

            <button
                    className={`focus:outline-none md:hidden ${currentUserId === userId ? 'text-gray-400 cursor-not-allowed' : 'text-red-400 hover:text-red-600'}`}
                    onClick={onDelete}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

        </div>
    </div>
    
    );
}

export default AgentCard